import { LogManager } from 'core/logging/LogManager';
import { httpClient } from 'core/net/http';
import { DateTime } from 'luxon';
import * as v from 'valibot';

const logger = LogManager.getLogger('updateActualBlastTime', { error: { logToServer: true } });

export async function updateActualBlastTime(value: DateTime, alias: string) {
  const response = await httpClient.useInternalApi
    .asAuthorised()
    .post(`/configuration/blasting/scenarios/${alias}/blast-time`, {
      utcActualBlastTime: value.toISO(),
    });

  if (!response.isSuccess) {
    const errorMessage = `Failed to update actual blast time for alias "${alias}", time "${value.toISO()}"`;
    logger.error(errorMessage);
    throw new Error(errorMessage);
  }

  const parsedData = v.safeParse(v.null(), response.data);

  if (!parsedData.success) {
    const errorMessage = `Failed to parse update actual blast time response for alias "${alias}", time "${value.toISO()}"`;
    logger.error(errorMessage, parsedData.issues);
    throw new Error(errorMessage);
  }

  return parsedData.output;
}
